import { createConsumer } from '@rails/actioncable';
import { BASE_URL } from './api';

let consumer = null;

export const getCableConsumer = () => {
    const token = localStorage.getItem('token');
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    let wsHost = BASE_URL || '';
    if (wsHost.startsWith('http')) {
        wsHost = wsHost.replace(/^http(s)?:/, wsProtocol);
    } else {
        wsHost = `${wsProtocol}//${window.location.host}`;
    }

    const cleanBase = wsHost.replace(/\/$/, '');
    const url = `${cleanBase}/cable?token=${encodeURIComponent(token || '')}`;

    if (!consumer) {
        consumer = createConsumer(url);
    }
    return consumer;
};

export const subscribeToPetReport = (reportId, { onReceived, onConnected, onDisconnected }) => {
    if (!reportId) return null;
    const cable = getCableConsumer();
    return cable.subscriptions.create(
        { channel: 'PetReportChannel', id: reportId },
        {
            connected() {
                if (onConnected) onConnected();
            },
            disconnected() {
                if (onDisconnected) onDisconnected();
            },
            received(data) {
                if (onReceived) onReceived(data);
            }
        }
    );
};
